<div class="container">
  <div class="dialog-header">
    <p i18n="@@writeReview">Leave a Review</p>
    <div (click)="closeDialog()"><img src="assets/close-icon.svg"></div>
  </div>
  <div class="write-review-message">
    <p i18n="@@writeReviewModalMessage">
      Your feedback helps us improve! Tap to leave a rating and share your experience.
    </p>
  </div>
  <div class="rate-your-experience">
    <p i18n="@@rateYourExperience">Rate your experience </p>
  </div>
  <div class="rate-container">
    <div *ngFor="let rate of [1,2,3,4,5]; let i = index;" (click)="setRate(rate)">
      <img [src]="getStarsImage(i)">
    </div>
  </div>
  <div class="rate-your-experience">
    <p i18n="@@yourReview">Your review (Optional)</p>
  </div>
  <div class="review-comment">
    <textarea placeholder="Type here" [formControl]="control"></textarea>
  </div>
  <div class="submit-button">
    <primary-button
      [loading]="isLoading"
      title="Submit"
      [enabled]="rate !== 0" (onClick)="submitRate()">
    </primary-button>
  </div>
</div>
